//IT MEANS STUDENT HEALTH AND INCIDENTS TRACKER

import { Add } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import { Typography, Button, useTheme } from "@mui/material";
import { useContext, useState } from "react";
import { UserContext } from "../App";
import IncidentModal from "./IncidentModal";

export default function Incidents(props) {
  const studentInfo = props.studentInfo;
  const theme = useTheme();

  const user = useContext(UserContext);

  const [modalOpen, setModalOpen] = useState(false);

  console.log(user);
  return (
    <>
      <IncidentModal
        studentInfo={studentInfo}
        open={modalOpen}
        setOpen={setModalOpen}
      />
      <div
        style={{
          border: ` 1px solid ${theme.palette.primary.main}`,
          padding: "20px",
          borderRadius: "5px",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <Typography variant="h5">Profiles Incidents</Typography>
          </div>

          <Button
            onClick={() => setModalOpen(true)}
            variant="outlined"
            startIcon={<AddIcon />}
          >
            New Incident
          </Button>
        </div>

        <div
          style={{
            width: "100%",
            display: "flex",
            minHeight: "200px",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography variant="body1" style={{ marginTop: "10px" }}>
            Nothing to report for {studentInfo[4]}.
          </Typography>
        </div>
      </div>
    </>
  );
}
